<template>
    <div class="py-4 bg-secondary" style="padding-bottom: 0px !important;">
        <div class="profile-page">
            <!-- shape Hero -->
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.contact')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>

            <section class="section py-3">
                <div class="container">
                    <!--                    <card shadow class="card-profile mt&#45;&#45;100 card_radius_no" no-body style="z-index: 10;">-->
                    <card shadow class="card-profile mt--100 card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('contact.contact_title')}} </span></div>
                            </div>
                            <div class="mt-3 py-3 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <p style="text-align: justify;">{{$t('contact.contact_title3')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
          <section class="section py-1 mb-3">
            <div class="container" >
              <div style="background: white; padding: 10px">
                <div>
<!--                  <h6 class="responsible-officials-title">-->
<!--                    {{  }}-->
<!--                  </h6>-->
                </div>
                <el-collapse>
                  <el-collapse-item  :title="$t('applicationProcedures')"  name="1">
                    <div style="background: white; padding: 10px" v-for="applicationProcedure in applicationProcedures">
                      <div v-html=" $i18n.locale === 'uz-UZ' ? applicationProcedure.contentUz : $i18n.locale === 'ru-RU' ? applicationProcedure.contentRu : applicationProcedure.contentUzCyr">
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </section>
            <section class="section py-1 mb-3">
                <div class="container">
                    <card shadow class="card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('contact.contact_title2')}}</span></div>
                            </div>
                            <div class="mt-3 py-3 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <div>
                                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><strong> {{$t('murojaat_qilish.murojaat_prokur')}} <br>
                                                {{$t('murojaat_qilish.murojaat_fuqaro')}} <br>
                                                {{$t('murojaat_qilish.murojaat_jadval')}}<br> </strong></div>
                                            <el-table
                                                    :data="rahbariyatlarQabul"
                                                    border
                                                    style="width: 100%">
                                                <el-table-column
                                                        prop="organ"
                                                        align="center"
                                                        :label="$t('murojaat_qilish.murojaat_jadval_qab1')">
                                                        <span slot-scope="{row, column, $index}">
                                                            <span v-if="$i18n.locale === 'uz-UZ'"> {{ row.positionUz}} </span>
                                                            <span v-if="$i18n.locale === 'ru-RU'"> {{ row.positionRu }} </span>
                                                            <span v-if="$i18n.locale === 'uz-CYR'"> {{ row.positionUzCyr }} </span>
                                                            <span v-if="$i18n.locale === 'en-US'"> {{ row.positionUz }} </span>
                                                            <br>
                                                            <strong v-if="$i18n.locale === 'uz-UZ'">{{ row.shortNameUz}}</strong>
                                                            <strong v-if="$i18n.locale === 'ru-RU'">{{ row.shortNameRu}}</strong>
                                                            <strong v-if="$i18n.locale === 'uz-CYR'">{{ row.shortNameUzCyr}}</strong>
                                                            <strong v-if="$i18n.locale === 'en-US'">{{ row.shortNameUz}}</strong>
                                                        </span>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="qabul"
                                                        align="center"
                                                        :label="$t('murojaat_qilish.murojaat_jadval_qab2')"
                                                        width="450">
                                                    <template slot-scope="{ row }">
                                                        <span v-if="$i18n.locale === 'uz-UZ'" v-html="row.recTimeUz"></span>
                                                        <span v-if="$i18n.locale === 'ru-RU'" v-html="row.recTimeRu"></span>
                                                        <span v-if="$i18n.locale === 'uz-CYR'" v-html="row.recTimeUzCyr"></span>
                                                        <span v-if="$i18n.locale === 'en-US'" v-html="row.recTimeUz"></span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
            <section class="section py-1 mb-3">
                <div class="container">
                    <card shadow class="card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('prokururor_tel.prokuror_title')}}</span></div>
                            </div>
                            <div class="mt-3 py-3 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <div>
                                        <el-collapse v-model="activePro" accordion>
<!--                                            <el-collapse-item :title="$t('prokururor_tel.prokuror_pro')" name="1" class="text-center">-->
                                            <el-collapse-item title="" name="1" class="text-center">
                                                <h4 class="display-3 text-titlecolor title_text mb-30" style="font-weight: 600 !important;">{{$t('prokururor_tel.prokuror_pro')}} </h4>
                                                <template>
                                                    <el-table
                                                            :data="regionProsecutors"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                prop="sortOrder"
                                                                label="№"
                                                                align="center"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="fullNameUz"
                                                                :label="$t('prokururor_tel.prokuror_pro_tel1')">
                                                          <template  slot-scope="{ row }" >{{ $i18n.locale === 'uz-UZ' ? row.fullNameUz :
                                                              $i18n.locale === 'en-US' ? row.fullNameUz :
                                                                                              $i18n.locale === 'ru-RU' ? row.fullNameRu :
                                                                                                  row.fullNameUzCyr }}
                                                          </template>

                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="positionUz"
                                                                align="center"
                                                                :label="$t('prokururor_tel.prokuror_pro_tel2')"
                                                                width="350">
                                                          <template  slot-scope="{ row }" >{{ $i18n.locale === 'uz-UZ' ? row.positionUz :
                                                              $i18n.locale === 'en-US' ? row.positionUz :
                                                                                              $i18n.locale === 'ru-RU' ? row.positionRu :
                                                                                                  row.positionUzCyr }}
                                                          </template>

                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="workPhone"
                                                                align="center"
                                                                :label="$t('prokururor_tel.prokuror_pro_tel3')"
                                                                width="250">
                                                        </el-table-column>
                                                    </el-table>
                                                </template>
                                            </el-collapse-item>
                                        </el-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
            <section class="section py-1 mb-3">
                <div class="container">
                    <card shadow class="card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('ishonch_tel.ishonch_title')}}</span></div>
                            </div>
                            <div class="mt-3 py-3 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <div>
                                        <el-collapse v-model="activeName" accordion>
                                            <el-collapse-item :title="$t('ishonch_tel.ishonch_pro_tel')" name="1" class="text-center">
<!--                                                <h4 class="display-3 text-titlecolor title_text mb-30" style="font-weight: 600 !important;">{{$t('ishonch_tel.ishonch_pro')}} </h4>-->
                                                <template>
                                                    <el-table
                                                            :data="regProsecutor"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                prop="sortOrder"
                                                                label="№"
                                                                align="center"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop=""
                                                                :label="$t('ishonch_tel.ishonch_pro_tel1')">
                                                              <template  slot-scope="{ row }" >{{ $i18n.locale === 'uz-UZ' ? row.nameUz :
                                                                  $i18n.locale === 'en-US' ? row.nameUz :
                                                                                                  $i18n.locale === 'ru-RU' ? row.nameRu :
                                                                                                      row.nameUzCyr }}
                                                              </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="code"
                                                                align="center"
                                                                :label="$t('ishonch_tel.ishonch_pro_tel2')"
                                                                width="150">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="phoneNumber"
                                                                align="center"
                                                                :label="$t('ishonch_tel.ishonch_pro_tel3')"
                                                                width="250">
                                                        </el-table-column>
                                                    </el-table>
                                                </template>
                                            </el-collapse-item>
                                        </el-collapse>
                                        <el-collapse v-model="activeName" accordion>
                                            <el-collapse-item :title="$t('ishonch_tel.ishonch_pro_tel6')" name="2" class="text-center">
                                                <template>
                                                    <el-table
                                                            :data="regDepartment"
                                                            border
                                                            style="width: 100%">
                                                        <el-table-column
                                                                prop="sortOrder"
                                                                label="№"
                                                                align="center"
                                                                width="50">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop=""
                                                                :label="$t('ishonch_tel.ishonch_pro_tel4')">
                                                          <template  slot-scope="{ row }" >{{ $i18n.locale === 'uz-UZ' ? row.nameUz : $i18n.locale === 'en-US' ? row.nameUz : $i18n.locale === 'ru-RU' ? row.nameRu : row.nameUzCyr }}</template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="code"
                                                                align="center"
                                                                :label="$t('ishonch_tel.ishonch_pro_tel2')"
                                                                width="150">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="phoneNumber"
                                                                align="center"
                                                                :label="$t('ishonch_tel.ishonch_pro_tel5')"
                                                                width="250">
                                                        </el-table-column>
                                                    </el-table>
                                                </template>
                                            </el-collapse-item>
                                        </el-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>

            <section class="section py-1 mb-3">
                <div class="container">
                    <el-row :gutter="15">
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                            <a href="https://pm.gov.uz/">
                                <div class="card card-lift shadow border-0 card-regstr_contact">
                                    <img src="img/brand/gerb_m.png" class="image_regstr_contact">
                                    <a href="https://pm.gov.uz/" class="regstr_contact vertical-center">
                                        <h2 class="card_h2_regstr_contact display-4">{{$t('contact.contact_title2')}}</h2>
                                        <span class="card_span_regstr_contact display-4">pm.gov.uz</span>
                                    </a>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                            <a href="tel:1007">
                                <div class="card card-lift shadow border-0 card-regstr_contact">
                                    <img src="img/icons/support.svg" class="image_regstr_contact">
                                    <a href="tel:1007" class="regstr_contact vertical-center">
                                        <h2 class="card_h2_regstr_contact display-4 ">{{$t('contact.contact_tel')}}</h2>
                                        <span class="card_span_regstr_contact display-4 ">1007</span>
                                    </a>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                          <router-link to="/korrupsiyaxabar">
                          <div class="card card-lift shadow border-0 card-regstr_contact">
                            <img src="img/logo/ProLogo_line_min.png" class="image_regstr_contact">
                            <div class="regstr_contact vertical-center">
<!--                              <h2 class="card_h2_regstr_contact display-4">-->
<!--                                {{$t('submenu.qabul')}}</h2>-->
                              <span class="card_span_time_contact" style="margin-top: 1px;" v-html="$t('submenu.pro_xabar')"></span>
                            </div>
                          </div>
                          </router-link>
                      </el-col>
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                            <a href="https://navbat.prokuratura.uz/">
                                <div class="card card-lift shadow border-0 card-regstr_contact">
                                    <img src="img/logo/ProLogo_line_min.png" class="image_regstr_contact">
                                    <div class="regstr_contact vertical-center">
                                        <h2 class="card_h2_regstr_contact display-4">
                                            {{$t('submenu.qabul')}}</h2>
                                        <span class="card_span_time_contact ">{{$t('submenu.boshprokuror_qabul')}}</span>
                                    </div>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                            <a href="#">
                                <div class="card card-lift shadow border-0 card-regstr_contact">
                                    <img src="img/icons/group.svg" class="image_regstr_contact">
                                    <div class="regstr_contact vertical-center">
                                        <h2 class="card_h2_regstr_contact display-4">
                                            {{$t('contact.contact_qabul')}}</h2>
                                        <span class="card_span_time_contact ">{{$t('contact.contact_tarmoq')}} {{$t('contact.contact_soat')}} 10:00 {{$t('contact.contact_dan')}} 17:00
                            {{$t('contact.contact_qadar')}}</span>
                                    </div>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="4" class="mb-3 mb-lg-10">
                        <a href="http://clinic.proacademy.uz/">
                          <div class="card card-lift shadow border-0 card-regstr_contact">
                            <img src="img/icons/support.svg" class="image_regstr_contact">
                            <a href="http://clinic.proacademy.uz/" class="regstr_contact vertical-center">
                              <h2 class="card_h2_regstr_contact display-4" style="font-size: 14px;">{{$t('contact.contact_maslahat')}}</h2>
                            </a>
                          </div>
                        </a>
                      </el-col>
                    </el-row>

                </div>
            </section>
          <section class="section py-1 mb-3">
            <div class="container" >
              <div style="background: white; padding: 10px" v-for="responsibleOfficial in responsibleOfficials">
                <h6 class="responsible-officials-title">
                  {{ $t('responsibleOfficials') }}
                </h6>
                <hr>
                <div v-html=" $i18n.locale === 'uz-UZ' ? responsibleOfficial.contentUz : $i18n.locale === 'en-US' ? responsibleOfficial.contentUz : $i18n.locale === 'ru-RU' ? responsibleOfficial.contentRu : responsibleOfficial.contentUzCyr">
                </div>
              </div>
            </div>
          </section>
        </div>
        <google-map/>
    </div>
</template>

<script>
    import GoogleMap from "./components/GoogleMap";
    import axios from "axios";

    export default {
        name: "home",
        data() {
            return {
              responsibleOfficials: [],
              applicationProcedures: [],
                centerDialogVisible: false,
                RegistrDialogVisible: false,
                input: '',
                input1: '',
                fuqarolik: [{
                    value: 'Ўзбекистон',
                    label: 'Ўзбекистон'
                }, {
                    value: 'Чет ел фуқароси',
                    label: 'Чет ел фуқароси'
                }, {
                    value: 'Фуқаролиги йўқ шахс',
                    label: 'Фуқаролиги йўқ шахс'
                }],
                value: '',
                rahbariyatlarQabul: [],
                regProsecutor: [],
                regDepartment: [],
                activeName: '1',
                activePro: '1',
                regionProsecutors: []
            };
        },
        mounted() {
          axios.get(`https://www.prokuratura.uz/api/responsible-officials`)
              .then(response => {
                this.responsibleOfficials = response.data
              })
          axios.get(`https://www.prokuratura.uz/api/application-properties`)
              .then(response => {
                this.applicationProcedures = response.data
              })
            axios
                .get(`https://www.prokuratura.uz/api/rahbariyats-for-web`)
                .then(response => {
                  this.rahbariyatlarQabul = response.data
                })
                .catch(error => {
                  console.log(error)
                })
            axios
                .get(`https://www.prokuratura.uz/api/reg-prosecutor-for-web`)
                .then(response => {
                  this.regionProsecutors = response.data
                })
                .catch(error => {
                  console.log(error)
                })
            axios
                .get(`https://www.prokuratura.uz/api/ishonchtel-for-web`)
                .then(response => {
                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].position === 'prosecutor') {
                      this.regProsecutor.push(response.data[i])
                    } else {
                      this.regDepartment.push(response.data[i])
                    }
                  }
                })
                .catch(error => {
                  console.log(error)
                })
        },
        // created() {
        //   for (let i = 0; i < this.ishonchtel.length; i++) {
        //     if (console.log(this.ishonchtel[i].position == 'prosecutor')) {
        //       this.regProsecutor = this.ishonchtel
        //     }
        //   }
        // },
        components: {
              GoogleMap
        }
    };
</script>
<style scoped>

.responsible-officials-title {
  font-size: 18px;
  text-transform: uppercase;
  display: block;
  text-align: center;
  margin: 15px 0;
}

    .backgroung_new {
        background-image: url("../../public/img/theme/bgnew2.png");
        z-index: 1000;
    }

    .el-table .cell {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }

    .button_new_system {
        left: 0px;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .icon_location {
        margin-left: 2px;
        font-size: 19px;
    }


</style>
